import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import {
    fetchYarnPOPendingDeliveryAtDropdown,
    fetchYarnPOPendingSupplierDropdown,
    fetchYarnPOProgramDropdown,
    fetchYarnPOSalesOrderDropdown,
    fetchYarnPOSupplierDropdown
} from '../../YarnPO/yarnPO/yarnPO.actions';
import { fetchFabricPOPreviousGetList, fetchFabricPoDetailsWithIdData } from '../fabricPoDetails/fabricPoDetails.action';
import {
    CREATE_FABRIC_PO_MASTER_FAILURE,
    CREATE_FABRIC_PO_MASTER_FORM,
    CREATE_FABRIC_PO_MASTER_REQUEST,
    CREATE_FABRIC_PO_MASTER_SUCCESS,
    DELETE_FABRIC_PO_MASTER_FAILURE,
    DELETE_FABRIC_PO_MASTER_REQUEST,
    DELETE_FABRIC_PO_MASTER_SUCCESS,
    FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_FABRIC_PO_MASTER_FAILURE,
    FETCH_FABRIC_PO_MASTER_REQUEST,
    FETCH_FABRIC_PO_MASTER_SUCCESS,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS,
    FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE,
    FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST,
    FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS,
    RESET_FABRIC_PO_MASTER_INFO,
    UPDATE_FABRIC_PO_MASTER_FAILURE,
    UPDATE_FABRIC_PO_MASTER_REQUEST,
    UPDATE_FABRIC_PO_MASTER_SUCCESS,
    FETCH_FABRIC_PO_INVOICE_REQUEST,
    FETCH_FABRIC_PO_INVOICE_SUCCESS,
    FETCH_FABRIC_PO_INVOICE_FAILURE,
    UPDATE_FABRIC_PO_REQUEST,
    UPDATE_FABRIC_PO_SUCCESS,
    UPDATE_FABRIC_PO_FAILURE
} from './fabricPoMaster.actionsType';

// FETCH PARTY MASTER DATA
export let fetchFabricPoMasterData = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricPoMasterGET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_FABRIC_PO_MASTER_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_MASTER_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE PARTY MASTER FORM
export let createFabricPoMasterForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_FABRIC_PO_MASTER_FORM, payload: { key, value } });
    };
};

// CREATE PARTY MASTER
export let createFabricPoMaster = (formData, modalClose, startDate, endDate, isDetail, unitId, salesId, styleId, ID) => {
    let today = new Date();
    let data = JSON.stringify({
        // fldId: 0,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldSupplierName: formData.fldSupplierName || '',
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldPoNo: 'auto generated',
        fldPoDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? parseInt(formData.fldFKDeliveryAt) : parseInt(formData.fldFKDeliveryAt),

        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldDeliveryLocation: 'string',
        fldDeliveryPlace: 'string',
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: null,
        fldVerifyBy: '',
        fldVerifyDate: null,
        fldAuthorizeBy: '',
        fldAuthorizeDate: null,
        fldInwardBy: '',
        fldInwardDate: null,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: 0,
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldAgainstSalesOrder: 0,
        fldItemsGrossValue: parseInt(formData.fldItemsGrossValue),
        fldItemsTaxableValue: parseInt(formData.fldItemsTaxableValue),
        fldItemsGSTValue: parseInt(formData.fldItemsGSTValue),
        fldItemsTotalValue: parseInt(formData.fldItemsTotalValue),
        fldDiscountPercentage: parseInt(formData.fldDiscountPercentage),
        fldDiscountValue: parseInt(formData.fldDiscountValue),
        fldGrandGrossValue: parseInt(formData.fldGrandGrossValue),
        fldOtherPlusValue: parseInt(formData.fldOtherPlusValue),
        fldOtherMinusValue: parseInt(formData.fldOtherMinusValue),
        fldRoundoff: parseInt(formData.fldRoundoff),
        fldGrandTotalValue: parseInt(formData.fldGrandTotalValue),
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldSupplierPANNo: '',
        fldSupplierPhoneNo: '',
        flDeliveryAtPANNo: '',
        fldDeliveryPhoneNo: '',
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldGenerateStyleDetailWise: formData.fldGenerateStyleDetailWise
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.fabricPoMasterPOST}`,
        responseTypeRequest: CREATE_FABRIC_PO_MASTER_REQUEST,
        responseTypeSuccess: CREATE_FABRIC_PO_MASTER_SUCCESS,
        responseTypeFailure: CREATE_FABRIC_PO_MASTER_FAILURE,
        resetFormData: isDetail ? FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB : RESET_FABRIC_PO_MASTER_INFO,
        modalClose,
        PoDcInwardType: 'PO',
        PoDcInwardNo: 'fldPONO',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [
            fetchFabricPOPreviousGetList(salesId, styleId),
            fetchFabricPoMasterData(startDate, endDate, unitId),
            fetchFabricPoDetailsWithIdData(ID)
        ]
        // getAllData: fetchFabricPoMasterData(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PARTY MASTER
export let getSingleFabricPoMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricPoMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE,
        singlApiArray: [
            // fetchSeasonMaster(),
            // fetchPartyDetailsData(),
            // fetchCommonPropertyById(52),
            // fetchCommonPropertyById(46),
            // fetchCommonPropertyById(28),
            // fetchUnitMaster(),
            // fetchYarnPOProgramDropdown('TblFabricPO'),
            // fetchYarnPOSupplierDropdown('TblFabricPO'),
            // fetchYarnPOPendingSupplierDropdown('FAI'),
            // fetchYarnPOPendingDeliveryAtDropdown(),
            // fetchYarnPOSalesOrderDropdown()
        ]
    };
    return axiosCall(config);
};

export let getFabricPOInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricPoInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_FABRIC_PO_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_INVOICE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PARTY MASTER
export let updateFabricPoMaster = (formData, id, startDate, endDate, unitId) => {
    let today = new Date();
    let data = {
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldSupplierName: '',
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldPoNo: formData?.fldPoNo,
        fldPoDate: formData.fldPoDate || today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),

        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldDeliveryLocation: 'string',
        fldDeliveryPlace: 'string',
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldInwardQty: formData.fldInwardQty,
        fldCancelQty: formData.fldCancelQty,
        fldBalanceQty: formData.fldBalanceQty,


        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldInwardBy: formData.fldInwardBy || '',
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate || null,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate || null,


        fldInwardDate: formData.fldInwardDate || null,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,

        fldModifiedBy: 11,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldAgainstSalesOrder: 0,
        // fldItemsGrossValue: parseInt(formData.fldItemsGrossValue),
        // fldItemsTaxableValue: parseInt(formData.fldItemsTaxableValue),
        // fldItemsGSTValue: parseInt(formData.fldItemsGSTValue),
        // fldItemsTotalValue: parseInt(formData.fldItemsTotalValue),
        // fldDiscountPercentage: parseInt(formData.fldDiscountPercentage),
        // fldDiscountValue: parseInt(formData.fldDiscountValue),
        // fldGrandGrossValue: parseInt(formData.fldGrandGrossValue),
        // fldOtherPlusValue: parseInt(formData.fldOtherPlusValue),
        // fldOtherMinusValue: parseInt(formData.fldOtherMinusValue),
        // fldRoundoff: parseInt(formData.fldRoundoff),
        // fldGrandTotalValue: parseInt(formData.fldGrandTotalValue),
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,

        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldIsAuthorized: formData.fldIsAuthorized,

        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldGenerateStyleDetailWise: formData.fldGenerateStyleDetailWise
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.fabricPoMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_FABRIC_PO_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_FABRIC_PO_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_FABRIC_PO_MASTER_FAILURE,
        resetFormData: RESET_FABRIC_PO_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchFabricPoMasterData(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PARTY MASTER
export let deleteFabricPoMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.fabricPoMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_FABRIC_PO_MASTER_REQUEST,
        responseTypeSuccess: DELETE_FABRIC_PO_MASTER_SUCCESS,
        responseTypeFailure: DELETE_FABRIC_PO_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchFabricPoMasterData(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchPropertyDataForFabricPoMasterMaster = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};

export let updateFabricPo = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.updatefabricPoApiCall}?FldId=${id}`,
        responseTypeRequest: UPDATE_FABRIC_PO_REQUEST,
        responseTypeSuccess: UPDATE_FABRIC_PO_SUCCESS,
        responseTypeFailure: UPDATE_FABRIC_PO_FAILURE
    };
    return axiosCall(config);
};
